var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content-section",staticStyle:{"height":"84%"}},[_c('video',{staticStyle:{"width":"100%","obiect-fit":"cover","overflow":"hidden"},attrs:{"src":_vm.banAPPList.videoUrl,"autoplay":"","loop":"","muted":""},domProps:{"muted":true}})]),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.isShowPlay,"width":"60%"},on:{"update:visible":function($event){_vm.isShowPlay=$event}}},[_c('video-player',{ref:"videoUrl",staticClass:"video-player vjs-custom-skin",staticStyle:{"width":"100%","border-radius":"4px"},attrs:{"playsinline":true,"options":{
	  			  playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
	  			  autoplay: true, //如果true,浏览器准备好时开始回放。
	  			  controls: true, //控制条
	  			  preload: true, //视频预加载
	  			  muted: false, //默认情况下将会消除任何音频。
	  			  loop: false, //导致视频一结束就重新开始。
	  			  language: 'zh-CN',
	  			  aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（
	  			  fluid: true,
	  			  sources: [
	  			    {
	  			      type: 'video/mp4',
	  			      src: _vm.currentRow.videoUrl
	  			    }
	  			  ],
	  			  poster:_vm.currentRow.videoCoverImg,
	  			  notSupportedMessage: '此视频暂无法播放，请稍后再试'
	  			}}})],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title"},[_c('div',{staticStyle:{"padding-top":"2%"}},[_vm._v("\n\t\t\t办案APP\n\t\t\t"),_c('img',{attrs:{"src":require("../assets/images/home_TitleLine.png")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13c78e9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home_three.vue
// module id = null
// module chunks = 